<template>
  <div
    class="main-index"
    :class="isSmallScreen ? 'small-screen-for-banner' : ''"
  >
    <!-- banner -->
    <div
      class="page-part banner"
      :style="{ backgroundImage: `url(${bannerPic})` }"
    >
      <div class="banner-text-wrap">
        <img src="~@/assets/financialCompetition/banner_text.png" alt="" />
        <a
          class="signe-btn"
          href="javascript:;"
          @click="handleSignUp"
          v-show="!logined || !competeUser.team_id"
          >立即报名</a
        >
        <a
          class="signe-btn"
          href="javascript:;"
          @click="viewMyTeam"
          v-show="competeUser.team_id"
          >已报名 查看我的队伍</a
        >
      </div>
    </div>
    <!-- 大赛简介 -->
    <div ref="introduce">
      <compete-introduce></compete-introduce>
    </div>
    <!-- 当前赛事 -->
    <div class="page-part round" ref="round">
      <compete-round />
    </div>
    <!-- 赛题参考 -->
    <div class="page-part questions" ref="questions">
      <competitionQuestions />
    </div>
    <!-- 大咖助阵 -->
    <div class="page-part big-shot" ref="bigShots">
      <bigShot />
    </div>
    <!-- 大赛奖励 -->
    <div class="page-part award" ref="award">
      <compete-award />
    </div>
    <!-- 赛事规则 -->
    <div class="page-part rules" ref="rules">
      <compete-rule></compete-rule>
    </div>
    <!-- 竞猜赛况 -->
    <!-- <div class="page-part reviews" ref="reviews">
      <competeViews />
    </div> -->
    <!-- 加入微信群 -->
    <div class="page-part contact">
      <compete-contact></compete-contact>
    </div>
    <suspend-anthor />
    <TeamUp v-model="stateShow.teamUp" @stateChange="handleStateChange" />
    <CreateTeam
      v-model="stateShow.createTeam"
      @stateChange="handleStateChange"
    />
    <CreateTeamSuccess
      v-model="stateShow.createTeamSuccess"
      @stateChange="handleStateChange"
    />
    <InviteTeamMate
      v-model="stateShow.inviteTeamMate"
      :inviteTeam="inviteInfo"
    />
    <JoinTeam v-model="stateShow.joinTeam" @stateChange="handleStateChange" />
    <JoinTeamCheck
      v-model="stateShow.joinTeamCheck"
      @stateChange="handleStateChange"
      :joinType="joinType"
    />
    <JoinTeamSearch v-model="stateShow.joinTeamSearch" />
    <TeamInvite
      v-model="stateShow.teamInvite"
      @stateChange="handleStateChange"
    />
    <JoinInviteTeam
      v-model="stateShow.joinInviteTeam"
      @stateChange="handleStateChange"
      :type="joinInviteResult"
    />
    <RemoveOutNotify
      v-model="stateShow.removeOutNotify"
      @stateChange="handleStateChange"
    />
    <MyTeam v-model="stateShow.myTeam" @stateChange="handleStateChange" />
    <RemoveTeamMate
      v-model="stateShow.removeTeamMate"
      @stateChange="handleStateChange"
    />
    <FinishFormTeam
      v-model="stateShow.finishFormTeam"
      @stateChange="handleStateChange"
    />
    <MyTeamCheck
      v-model="stateShow.myTeamCheck"
      @stateChange="handleStateChange"
    />
  </div>
</template>

<script>
import store from '../../store'
import { mapGetters, mapActions } from 'vuex'
import Api from '@/api/competition/financialIndex'
import {
  competeRound,
  competeAward,
  bigShot,
  competeIntroduce,
  competeRule,
  competeContact,
  // competeViews,
  suspendAnthor,
  competitionQuestions
} from './components'
import {
  TeamUp,
  CreateTeamSuccess,
  CreateTeam,
  InviteTeamMate,
  JoinTeam,
  JoinTeamCheck,
  JoinTeamSearch
} from './components/TeamUp'
import {
  TeamInvite,
  JoinInviteTeam,
  RemoveOutNotify
} from './components/TeamInvite'
import {
  MyTeam,
  FinishFormTeam,
  RemoveTeamMate,
  MyTeamCheck
} from './components/MyTeam'

export default {
  name: 'mainIndex',
  components: {
    competeRound,
    competeAward,
    bigShot,
    competeIntroduce,
    competeRule,
    competeContact,
    suspendAnthor,
    competitionQuestions,
    TeamUp,
    CreateTeamSuccess,
    CreateTeam,
    InviteTeamMate,
    JoinTeam,
    JoinTeamCheck,
    JoinTeamSearch,
    TeamInvite,
    JoinInviteTeam,
    RemoveOutNotify,
    MyTeam,
    FinishFormTeam,
    RemoveTeamMate,
    MyTeamCheck
  },
  data() {
    return {
      logined: false, // 是否登录
      isSmallScreen: false, // 是否为小屏
      bannerPic: window.financialCompetitionResource.bannerPicUrl,
      curState: '',
      // 队伍相关弹框状态
      stateShow: {
        teamUp: false, // 展示组队选择弹框
        createTeam: false, // 创建队伍弹框
        createTeamSuccess: false, // 队伍创建成功弹框
        inviteTeamMate: false, // 邀请队友弹框
        joinTeam: false, // 加入队伍
        joinTeamCheck: false, // 加入【主动加入和受邀加入】队伍个人信息确认弹框
        joinTeamSearch: false, // 加入【主动加入】队伍时查找队伍的方法提示弹框
        myTeam: false, // 我的队伍【完成组队】
        finishFormTeam: false, // 完成组队提示【完成将无法添加新成员】弹框
        removeTeamMate: false, // 移除成员提示弹框
        myTeamCheck: false, // 队伍信息弹框
        teamInvite: false, // 受邀加入队伍弹框
        joinInviteTeam: false, // 加入邀请队伍结果弹框
        removeOutNotify: false // 被队伍移除通知
      },
      joinType: 'join', // 加入队伍的类型，join：主动加入队伍，invite：受邀加入队伍
      joinInviteResult: '', // 加入队伍结果，success：成功，fail：失败
      inviteInfo: {} // 邀请信息【队伍名称和邀请地址】
    }
  },
  computed: {
    ...mapGetters(['competeUser', 'user'])
    // ...mapGetters(['hsid'])
  },
  created() {
    this.logined = Api.isUserLogined()
    this.getCompanyList()
  },
  mounted() {
    const guajian = document.getElementById('gtn-gj-id')
    if (guajian) {
      guajian.style.display = 'none'
    }
    window.addEventListener('resize', this.selfAdaption, false)
    this.selfAdaption()
    if (Api.isUserLogined()) {
      this.getCompetInfo()
    } else {
      this.checkIfHasTeamInvite() // 校验是否受邀
    }
    const hsid = store.getters.hsid
    hsid && gdp('setUserId', hsid)
    gdp('track', 'GL_loginUserPageBrowse', {
      pageName_var: '2022杭州市金融系统云技术职工技能大赛',
      appId_var: 5525,
      domainId_var: '-',
      hsUserId_var: hsid || '-'
    })
  },
  methods: {
    ...mapActions(['GetCompeteUser', 'GetBeInviteTeam', 'getCompanyList']),
    // 获取参赛信息
    getCompetInfo() {
      this.GetCompeteUser().then(
        (res) => {
          if (res) {
            if (res.last_team) {
              this.stateShow.removeOutNotify = true
            }
          }
          this.checkIfHasTeamInvite() // 校验是否受邀
        },
        (err) => {}
      )
    },
    // 处理报名按钮点击
    handleSignUp() {
      // 登录的情况下
      if (Api.isUserLogined()) {
        this.stateShow.teamUp = true
        this.curState = 'teamUp'
        this.joinType = 'join'
      } else {
        // 如果未登录，则进行登录
        this.$hMsgBox.confirm({
          title: '',
          content: '您还没有登录，请点击前往登录',
          onOk: () => {
            this.$goLoginUrl()
          }
        })
      }
    },
    // 处理查看队伍信息按钮点击
    viewMyTeam() {
      this.GetCompeteUser().then(
        (res) => {
          if (res.last_team) {
            this.stateShow.removeOutNotify = true
          } else {
            if (this.competeUser.team_state === '0') {
              this.stateShow.myTeam = true
              this.curState = 'myTeam'
            }
            if (this.competeUser.team_state === '1') {
              this.stateShow.myTeamCheck = true
              this.curState = 'myTeamCheck'
            }
          }
        },
        (err) => {
          this.$hMessage.error('获取我的队伍失败')
        }
      )
    },
    // 处理队伍相关弹框状态的改变
    handleStateChange(nextState, data) {
      this.stateShow[this.curState] = false
      this.getEmitDataWithState(nextState, data)
      if (nextState) {
        this.curState = nextState
        this.stateShow[nextState] = true
      }
    },
    // 校验是否有被邀请
    checkIfHasTeamInvite() {
      let teamId = this.$route.query.teamId
      if (teamId) {
        this.GetBeInviteTeam(teamId).then(
          (res) => {
            // 如果已存在队伍信息，则不需要展示邀请提示弹框，直接将地址后面的teamId给去掉即可
            if (this.competeUser && this.competeUser.current_team) {
              this.$hMessage.info({
                content: '您已加入过队伍！',
                duration: 2
              })
              setTimeout(() => {
                history.replaceState(
                  null,
                  null,
                  window.location.href
                    .replace(/(\?).*(?=#)/, '')
                    .replace(/(\?)teamId=([^&#]*)([&#]|$)/, '')
                    .replace(/(&)teamId=([^&#]*)([&#]|$)/, '')
                )
              }, 2000)
            } else {
              this.stateShow.teamInvite = true
              this.curState = 'teamInvite'
              this.joinType = 'invite'
            }
          },
          (error) => {}
        )
      }
    },
    // 根据下个要展示弹框的状态【名称】，获取部分弹框中触发的数据
    getEmitDataWithState(nextState, data) {
      if (data && nextState === 'inviteTeamMate') {
        this.inviteInfo = { ...data }
      }
      if (data && nextState === 'joinInviteTeam') {
        this.joinInviteResult = data
      }
    },
    // 页面自适应
    selfAdaption() {
      const oWidth =
        document.documentElement.clientWidth ||
        document.body.clientWidth ||
        window.innerWidth
      if (oWidth <= 1440) {
        this.isSmallScreen = true
      } else {
        this.isSmallScreen = false
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.selfAdaption, false)
  },
  watch: {
    user() {
      this.logined = Api.isUserLogined()
      this.getCompetInfo()
    }
  }
}
</script>


<style lang="scss" scoped>
.main-index {
  width: 100%;
  position: relative;
  background-color: #f7f7f7;
  .banner {
    height: 478px;
    background: url('#') center center/cover no-repeat;
  }
  .banner-text-wrap {
    width: 1200px;
    margin: 0 auto;
    padding-top: 121px;
    img {
      width: 593px;
      margin-left: 35px;
    }
    a {
      width: 256px;
      border-radius: 25px;
      font-size: 16px;
      color: #fff;
      display: block;
      height: 47px;
      line-height: 47px;
      text-align: center;
      background-image: linear-gradient(to right, #3060ff, #5db7ff);
      margin: 24px 0 0 210px;
    }
  }
  .round {
    overflow: hidden;
  }
  .award {
    height: 757px;
    background-color: #fff;
    padding-top: 64px;
  }
  .big-shot {
    background: #f7f7f7 url('~@/assets/competition/bg-rules-2x.png') center
      center/cover no-repeat;
  }
  .contact {
    background-color: #f6f8ff;
  }
  .reviews {
    background-color: #fff;
    height: 753px;
    padding: 64px 0 76px;
  }
  .footer {
    background: #252e49;
    height: 464px;
  }
}
.small-screen-for-banner {
  .banner {
    height: 396px;
    background-size: auto 396px;
  }
  .banner-text-wrap {
    padding-top: 100px;
    img {
      width: 486px;
    }
    a {
      width: 215px;
      border-radius: 21px;
      font-size: 13px;
      height: 39px;
      line-height: 39px;
      margin: 20px 0 0 174px;
    }
  }
}
</style>
<style lang="scss">
.animate__fadeInUp {
  --animate-duration: 500ms;
  --animate-delay: 0ms;
}
.financial-competition-page {
  #light-common-header {
    position: relative !important;
    .header-wrapper {
      background-color: rgba(247, 247, 247, 0.8);
      // position: relative;
      // height: auto;
    }
    .header-wrapper {
      &:hover {
        border-bottom: none;
        .header-function-btn .loginIn-btn {
          color: #333 !important;
        }
      }
    }
    .header-wrapper-hover {
      .header-function-btn .loginIn-btn {
        color: #333 !important;
      }
    }
    .gtn-topbar-element,
    .header-search-wrapper,
    .header-function-btn > a {
      display: none;
    }
    .logo-wrapper {
      position: relative;
      width: 321px;
      background: url('~@/assets/financialCompetition/logo_multi@2x.png')
        center/321px 24px no-repeat;
      height: 60px;
      img {
        display: none;
      }
    }
  }
}
.financial-competition-modal .h-modal-content {
  border-radius: 25px;
}
.financial-competition-modal .h-modal-close {
  color: #858585;
}
.financial-competition-modal {
  .h-description-item .h-description-item-context.context-ellipsis {
    overflow: initial !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/financialCompetitionViews/index.vue